import styled from 'styled-components';
import {mobileMedia} from '../../../../globalVariables/GlobalVariables';
import {update} from '../../../../assets/symbols/symbols/Symbols.css';
import zIndex from '../../../../globalVariables/zIndex';
import {dFlexStartBetween} from '../../../../globalVariables/GlobalFlex';
import {getColor} from '../../utils/themeUtils';

export const lastUpdate = styled.div`
    position: relative;
    inset-inline-start: calc(10% + 5px);
    inset-block-start: 50px;
    color: ${p=>getColor(p.theme.isDarkMode)};
    width: fit-content;
    ${dFlexStartBetween};
    gap: 5px;
    &::before{
        display: block;
        content: '';
        height: 20px;
        width: 20px;
        background-color: ${p=>getColor(p.theme.isDarkMode)};
        -webkit-mask-image: url("${update}");
        mask-image: url("${update}");
        -webkit-mask-position:center center;
        -webkit-mask-repeat: no-repeat;
        -webkit-mask-size: 20px;
        position: relative;
    }
    ${mobileMedia}{
        margin-bottom: 20px;
        inset-block-start: 0;
        inset-inline-start: calc(2% + 30px);
    }
`;
export const updateButton = styled.div`
    cursor: pointer;
    color: ${p=>getColor(p.theme.isDarkMode)};
    position: relative;
    z-index: ${zIndex.baseHigh};
    text-decoration: underline; 
`;
